/**
 *  Date    : 2019/11/7
 *  Author  : Weilin
 *  Declare : user
 */
import Immutable from 'seamless-immutable';

import labelApi from '@/api/labelapi';
import bookapi from '@/api/bookapi';

export default {
  namespace: 'label',
  state: Immutable({
    labelGroupList: [],
    purLabelList: [],
    bookLabelList: []
  }),
  reducers: {
    update: (state, { data, field }) => state.merge({ [field]: data })
  },
  actions: {
    /** 获取专业深度标签 */
    getLabelGroupList(payload) {
      return {
        type: 'label/update/getLabelGroupList',
        field: 'labelGroupList',
        promise: labelApi.labelGroupList(payload).catch(err => [])
      };
    },
    /** 获取目的标签 */
    getPurLabelList(payload) {
      return {
        type: 'label/update/getPurLabelList',
        field: 'purLabelList',
        promise: labelApi.purLabelList(payload)
      };
    },
    /** 获取图书标签 */
    getBookLabelList(payload) {
      return {
        type: 'label/update/getBookLabelList',
        field: 'bookLabelList',
        promise: bookapi.getBookLabels(payload)
      };
    }
  }
};
